import { requestMfaProcedureSuccess } from 'common/components/ModalMFA/actions';
import type { AppDispatch } from 'modules/app/redux/store';
import { postV2ApiCompanyIdCardsIncreaseLimitsRequest } from 'src/client/spendesk-api';
import type { PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest } from 'src/client/spendesk-api-types';

export type PostCardLimitsIncreaseInitiateProcedureInput = {
  authenticationMethod: PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest['body']['authenticationMethod'];
  companyId: string;
  description: string;
  useSmsFallback?: boolean;
};

type PostCardLimitsIncreaseInitiateProcedureResponse = {
  procedureId: string;
  factorId?: string;
};

export const postCardLimitsIncreaseInitiateProcedure = async (
  {
    authenticationMethod,
    companyId,
    description,
  }: PostCardLimitsIncreaseInitiateProcedureInput,
  // Dispatching is only used for the SMS fallback flow.
  dispatch?: AppDispatch,
): Promise<PostCardLimitsIncreaseInitiateProcedureResponse> => {
  const response = await postV2ApiCompanyIdCardsIncreaseLimitsRequest({
    path: {
      companyId,
    },
    body: {
      authenticationMethod,
      description,
    },
  });

  if (response.statusCode !== 200) {
    throw new Error('Failed to initiate card limits increase SCA procedure.');
  }

  const { procedureId, factorId } = response.body;

  if (authenticationMethod === 'mfa' && factorId && dispatch) {
    // Dispatching so that it would be used by ModalMFAToken
    dispatch(
      requestMfaProcedureSuccess({
        id: procedureId,
        factorId,
      }),
    );
  }

  return {
    procedureId,
    factorId,
  };
};
